export default { sha: 'be16e27bb24e6254490502e2acfe7f585b655aa4', buildNumber: 'undefined' }
